import { useState } from 'react';

import './expandable-text.scss';

export const ExpandableText = ({ text, maxChars = 100, canExpand = true }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isTruncated = text.length > maxChars;
  const displayText = expanded || !isTruncated ? text : text.slice(0, maxChars) + '…';

  return (
    <span className="expandable-text">
      {displayText}{' '}
      {isTruncated && canExpand && (
        <button
          className="expandable-text__toggle"
          onClick={(e) => {
            e.stopPropagation();
            setExpanded(!expanded);
          }}
        >
          {expanded ? 'show less' : 'show more'}
        </button>
      )}
    </span>
  );
};
